const configVariables = {
  baseURL: import.meta.env.VITE_BASE_URL,
  siteBuilderURL: import.meta.env.VITE_SITE_BUILDER_URL,
  isBrRegulation: import.meta.env.VITE_IS_BR_REGULATION && JSON.parse(import.meta.env.VITE_IS_BR_REGULATION),
  env: import.meta.env.VITE_ENV,
};

const Config = {
  ...configVariables,
  xhr: {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
    },
  },
};

export default Config;
